import React from 'react';

export default () => (<div className="project" id="project-1">
  <div className="slogan">
    <img src={process.env.PUBLIC_URL + '/images/project/project-1-slogan.png'} alt="药用植物及经济作物新型苗孵化基地及推广种植" />
  </div>
  <div className="content">
    <div id="constructions">
      <div className="title">
        <span>建设内容</span>
      </div>
      <div className="constructions">
        <div className="construction" id="construction-1">
          <div className="icon icon-project-construction-first"></div>
          <div className="name">
            <span>药用及经济作物的苗孵化</span>
          </div>
          <div className="desc">
            <span>全自动化温室</span>
            <span>快繁幼苗培育园</span>
            <span>优良品种亩本园</span>
          </div>
        </div>
        <div className="construction" id="construction-2">
          <div className="icon icon-project-construction-second"></div>
          <div className="name">
            <span>农村合作社的组建</span>
          </div>
          <div className="desc">
            <span>推广种植</span>
            <span>产销联合</span>
            <span>产品的深加工</span>
          </div>
        </div>
        <div className="construction" id="construction-3">
          <div className="icon icon-project-construction-third"></div>
          <div className="name">
            <span>基础设施的建设</span>
          </div>
          <div className="desc">
            <span>道路的建设</span>
            <span>给排水的建设</span>
            <span>环境建设</span>
            <span>固定资产的投入</span>
          </div>
        </div>
      </div>
    </div>
    <div className="crossline-container">
      <div id="advantages">
        <div className="title">
          <div className="icon icon-project-advantages"></div>
          <div className="name">项目特色及优势</div></div>
        <div className="advantage">
          <span>药用作物及经济作物苗的快繁技术，实现苗孵化的工厂化、快速化，可实现一些难育苗的植物的苗孵化，技术含量高，可带动西北五省的苗的需求，具体辐射带动作用。</span>
        </div>
        <div className="advantage">
          <span>经济价值高、可综合利用。基地苗孵化的比如七叶树、美洲黄芪、树莓、虎眼万年青等名贵经济作物，经济价值高，可综合利用，对周边农民的致富带动能力强。集育苗、科研、种植、加工、观光一体化，具有功能复合性，可作为全国现代经济林区的标准。</span>
        </div>
        <div className="advantage">
          <span>基地集实验观光、育苗、推广种植、回收、深加工、销售为一体，产业链长，可发展潜力打，可做大做强，对产业链的拉伸具有较强的能力。植物深加工工厂对镇安乃至秦岭山区的经济作物的产业的深加工具有帮助带头作用。</span>
        </div>
        <div className="advantage">
          <span>基地实现有机化全产业链，对秦岭山区的生态保护起到带头示范作用。基地将秦岭山区较为稀缺的经济作物和药用植物作一个立体式展示，集具秦岭植物特色、山水文化、生物资源，是一个较好的展示平台。</span>
        </div>
      </div>
    </div>
    <div id="extras">
      <div className="extra tech-feature">
        <div className="icon icon-project-tech-features"></div>
        <div className="title">
          技术特点
        </div>
        <div className="desc">
          <div>非试管快繁技术</div>
          <div>（已申请国家专利）</div>
        </div>
      </div>
      <div className="extra tech-advantage">
        <div className="icon icon-project-tech-advantages"></div>
        <div className="title">
          技术优势
        </div>
        <div className="desc">
          <div>生根时间短，繁殖速度快</div>
          <div>再生苗健壮，成活率高</div>
          <div>丰产性好，后代无变异</div>
          <div>技术步骤少，易于推广</div>
        </div>
      </div>
      <div className="extra eco-feature">
        <div className="icon icon-project-eco-feature"></div>
        <div className="title">
          经济效益
        </div>
        <div className="desc">
          <div>利润800万元</div>
          <div>利税百万以上</div>
          <div>增加农民收入</div>
          <div>社会效益</div>
          <div>示范推广作用</div>
          <div>带动周边农民就业</div>
          <div>绿色无污染</div>
        </div>
      </div>
    </div>
    <div className="background"></div>
  </div>
</div>
);